import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {accordion} from "./modules/accordion";
import {appsSlider} from "./modules/appsSlider";
import {tabs} from "./modules/tabs";
import {customSelect} from "./modules/customSelect";
import {popups} from "./modules/popups";
import {counter} from "./modules/counter";
import {postsSlider} from "./modules/postsSlider";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {postSectionSlider} from "./modules/postSectionSlider";
import {solitionsSlider} from "./modules/solitionsSlider";
import {videoBlock} from "./modules/videoBlock";
import {cardsSlider} from "./modules/cardsSlider";
import {heroAdaptiveBg} from "./modules/heroAdaptiveBg";
import {raitingStars} from "./modules/raitingStars";
import {header} from "./modules/header";
import {fullHeightPage} from "./modules/fullHeightPage";
import {menuBlogSlider} from "./modules/menuBlogSlider";
import {heroMediaAdaptiveBg} from "./modules/heroMediaAdaptiveBg";
import {heroCardsAdaptiveBg} from "./modules/heroCardsAdaptiveBg";
import {heroShapedImagesAdaptiveBg} from "./modules/heroShapedImagesAdaptiveBg";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {stickyNav} from "./modules/stickyNav";
import {reviewsSlider} from "./modules/reviewsSlider";
import {pricingPlans} from "./modules/pricingPlans";
import {animationOnScroll} from "./modules/animationOnScroll";
import {heroVideoAnimation} from "./modules/heroVideoAnimation";
import {cardsVideo} from "./modules/loadedVideo";

binder({
    bounds: {
        "html": [constants, header, fullHeightPage],
        ".has-animation": animationOnScroll,
        ".accordion": accordion,
        ".apps-slider": appsSlider,
        ".tabs-holder": tabs,
        ".popups": popups,
        ".has-counters-animation": counter,
        "select": customSelect,
        ".posts-slider": postsSlider,
        ".testimonials-section": testimonialsSlider,
        ".posts-section.has-slider": postSectionSlider,
        ".process-overview": solitionsSlider,
        ".video-block": videoBlock,
        ".cards-list": cardsSlider,
        ".has-video-container": heroAdaptiveBg,
        ".raiting-block": raitingStars,
        ".menu-blog-slider": menuBlogSlider,
        ".hero-section.with-media": heroMediaAdaptiveBg,
        ".hero-section.has-cards": heroCardsAdaptiveBg,
        ".hero-section.has-shaped-images": heroShapedImagesAdaptiveBg,
        ".copy-link": copyLinkToBuffer,
        ".aside-menu": stickyNav,
        ".reviews-slider": reviewsSlider,
        ".pricing-plans": pricingPlans,
        ".video-block-animation": heroVideoAnimation,
        ".cards-grid": cardsVideo
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js